import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Icon from '../../common/components/Icon';

import './FieldInfo.css';

const FieldInfo = ({ children, id, placement = 'right' }) => (
    <OverlayTrigger
        trigger={['hover', 'click']}
        placement={placement}
        overlay={<Popover className="form-field-info-popover" id={id}>{children}</Popover>}
    >
        <button type="button" className="form-field-info-button"><Icon icon="info" /></button>
    </OverlayTrigger>
);

FieldInfo.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node,
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
};

export default FieldInfo;
